import { Formik, Form as FormikForm } from 'formik';
import React, { useEffect, useState } from 'react';
import { Col, Form, Modal, Row, Spinner, Table } from 'react-bootstrap';
import { FaPlus } from "react-icons/fa6";
import { MdKeyboardBackspace, MdOutlineClose } from "react-icons/md";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Select from "react-select";
import Input from '../../../Components/Input/Input';
import Pagination from '../../../Components/Pagination/Pagination';
import { addDepartment, getAllTenders, getDepartments, selectDepartment } from '../../../Redux/Action/Dashboard';
import { dashboardColorStyles, fileBaseUrl, formatDate, statusCheck, tenderDate } from '../../../Utils/Helper';
import Loader from '../../../Utils/Loader';
import { errorNotify, successNotify } from '../../../Utils/Toast';
import { addCompanySchema } from '../../../Utils/Validations';

const TenderDetails = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [show, setShow] = useState(false)
    const [show2, setShow2] = useState(false)
    const [detailShow, setDetailShow] = useState({
        show: false,
        text: ''
    })
    const [department, setDepartment] = useState('')
    const [saveTenderId, setSaveTenderId] = useState('')
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);

    const { loading, allTendersData } = useSelector((state) => state.getAllTendersData)
    const { loading: departmentLoading, getDepartmentsData } = useSelector((state) => state.departmentsGet)
    const { loading: selectedLoading, selectDepartmentData, error: selectDepartmentError } = useSelector((state) => state.departmentSelect)
    const { loading: createLoading, addDepartmentData, error: addDepartmentError } = useSelector((state) => state.departmentAdd)

    useEffect(() => {
        if (currentPage !== 1) {
            setCurrentPage(1);
        }
    }, [limit])

    useEffect(() => {
        const formData = new FormData();
        formData.append("company", id)

        dispatch(getAllTenders(formData, currentPage, limit))
        dispatch(getDepartments())

    }, [currentPage, limit])

    useEffect(() => {
        if (selectDepartmentData?.statusCode === 200) {
            successNotify("Assigned Successfully!")
            dispatch({ type: "SELECT_DEPARTMENT_RESET" })
            setShow(false)

            const companyFormData = new FormData();
            companyFormData.append("company", id)

            dispatch(getAllTenders(companyFormData, currentPage, limit))
        }
        else {
            if (selectDepartmentError) {
                errorNotify(selectDepartmentError)
                dispatch({ type: "SELECT_DEPARTMENT_RESET" })
            }
        }
    }, [selectDepartmentData])

    useEffect(() => {
        if (addDepartmentData?.statusCode === 200) {
            successNotify("Department Add Successfully!");
            dispatch({ type: "ADD_DEPARTMENT_RESET" })
            setShow2(false)

            dispatch(getDepartments())
        }
        else {
            if (addDepartmentError) {
                errorNotify(addDepartmentError)
                dispatch({ type: "ADD_DEPARTMENT_RESET" })
            }
        }
    }, [addDepartmentData, addDepartmentError])

    const selectTender = (data, name) => {
        if (name === "select") {
            setSaveTenderId(data.id)
            setShow(true)
        }
        else if (name === "detail") {
            setDetailShow({
                show: true,
                text: data.detail
            })
        }
    }

    const createCompanyHandler = (values) => {
        const formData = new FormData();
        formData.append("name", values.name)
        formData.append("pocName", values.pocName)
        formData.append("pocContact", values.pocContact)
        formData.append("emails", values.email)

        dispatch(addDepartment(formData))
    }

    const selectedHandler = () => {
        if (department.length === 0 || saveTenderId.length === 0) {
            errorNotify("Please select Department")
            return;
        }

        const formData = new FormData();
        formData.append("department_id", department)
        formData.append("active_tender_id", saveTenderId)

        dispatch(selectDepartment(formData))
    }

    const departOptions = getDepartmentsData?.data?.length > 0 ? getDepartmentsData?.data?.map((d) => {
        return {
            value: d?.id, label: d.name
        }
    }) : []

    const modal2 = <Modal centered className='doc_type' show={show2}>
        <Modal.Body>
            <div className='add_doc_type' style={{ transition: "all 0.3s ease" }}>
                <div className='head'>
                    <h5>Add Department</h5>
                    <MdOutlineClose onClick={() => setShow2(false)} />
                </div>

                <Formik
                    initialValues={{
                        name: '',
                        pocName: '',
                        pocContact: '',
                        email: ''
                    }}
                    validationSchema={addCompanySchema}
                    onSubmit={createCompanyHandler}
                >
                    {() => (
                        <FormikForm>
                            <Row>
                                <Col md={6} className='mb-3'>
                                    <Input
                                        type="text"
                                        name="name"
                                        label="Department Name"
                                        placeholder="Enter company name"
                                    />
                                </Col>
                                <Col md={6} className='mb-3'>
                                    <Input
                                        type="email"
                                        name={`email`}
                                        label={`Email`}
                                        placeholder="Enter Email Address"
                                    />
                                </Col>
                                <Col md={6} className='mb-3'>
                                    <Input
                                        type="text"
                                        name="pocName"
                                        label="POC Name"
                                        placeholder="Enter POC name"
                                    />
                                </Col>
                                <Col md={6} className='mb-3'>
                                    <Input
                                        type="text"
                                        name="pocContact"
                                        label="POC Contact"
                                        placeholder="Enter POC contact"
                                        min={11}
                                        max={11}
                                    />
                                </Col>
                                {/* <Col md={12} className='mb-3'>
                                    <Input
                                        type="number"
                                        name="emailCount"
                                        label="Number of Emails"
                                        placeholder="Enter number of emails"
                                        min={1}
                                        max={5}
                                        value={values.emailCount}
                                        onChange={(e) => {
                                            const count = parseInt(e.target.value);
                                            setFieldValue('emailCount', count);

                                            const currentEmails = [...values?.emailNames];
                                            if (count > currentEmails.length) {
                                                while (currentEmails.length < count) {
                                                    currentEmails.push('');
                                                }
                                            } else {
                                                while (currentEmails.length > count) {
                                                    currentEmails.pop();
                                                }
                                            }
                                            setFieldValue('emailNames', currentEmails);
                                        }}
                                    />
                                </Col>
                                {values.emailNames?.map((_, index) => (
                                    <Col md={6} key={index} className='mb-3'>
                                        <Input
                                            type="email"
                                            name={`emailNames.${index}`}
                                            label={`Email ${index + 1}`}
                                            placeholder="Enter Email Address"
                                        />
                                    </Col>
                                ))} */}
                                <Col md={12}>
                                    <div className='next_btn'>
                                        <button type='submit'>
                                            {createLoading ? <Spinner animation='border' size='sm' /> : "Create"}
                                        </button>
                                    </div>
                                </Col>
                            </Row>
                        </FormikForm>
                    )}
                </Formik>
            </div>
        </Modal.Body>
    </Modal>

    const modal = <Modal centered className='doc_type' show={show}>
        <Modal.Body>
            <div className='add_doc_type' style={{ transition: "all 0.3s ease" }}>
                <div className='head'>
                    <h5>Select Department</h5>
                    <MdOutlineClose onClick={() => setShow(false)} />
                </div>
                <Form >
                    <Row>
                        <Col md={12}>
                            <Form.Group className="mb-3">
                                <Form.Label>Department <span>*</span> <FaPlus onClick={() => setShow2(true)} /> </Form.Label>
                                <Select
                                    isLoading={departmentLoading} options={departOptions}
                                    onChange={(e) => setDepartment(e.value)}
                                    placeholder="Select Department" styles={dashboardColorStyles} />
                            </Form.Group>
                        </Col>
                        <Col md={12}>
                            <div className='next_btn'>
                                <button type='button' onClick={selectedHandler}
                                    disabled={selectedLoading}
                                >
                                    {selectedLoading ? <Spinner animation='border' size='sm' /> : "Submit"}
                                </button>
                            </div>
                        </Col>
                    </Row>
                </Form>
            </div>
        </Modal.Body>
    </Modal>

    const modal3 = <Modal centered className='doc_type' show={detailShow.show}>
        <Modal.Body>
            <div className='add_doc_type' style={{ transition: "all 0.3s ease" }}>
                <div className='head'>
                    <h5>Tender Detail</h5>
                    <MdOutlineClose onClick={() => setDetailShow({ show: false, text: '' })} />
                </div>

                <div className='m-4'>
                    <label style={{ fontWeight: "700", marginBottom: "5px" }}>Detail Text</label>
                    <p style={{ marginBottom: "30px" }}>{detailShow.text}</p>
                </div>
            </div>
        </Modal.Body>
    </Modal>

    return (
        <div className='table_main'>
            {modal} {modal2} {modal3}
            <div className='application_main'>

                <h1 style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <MdKeyboardBackspace style={{ cursor: "pointer", fontSize: "27px" }} onClick={() => navigate('/dashboard/all-tenders')} />
                    {id}
                </h1>
                {
                    loading ? <div className='py-3'>
                        <Loader />
                    </div> :
                        <div className='application_table'>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>S No.</th>
                                        <th>Tender No.</th>
                                        <th>Company</th>
                                        <th>Advertise Date</th>
                                        <th>Closing Date</th>
                                        <th>Closing Time</th>
                                        <th>Document</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        allTendersData?.data.results?.map((r, i) => {
                                            return (
                                                <tr key={i}>
                                                    <td>{i + 1}</td>
                                                    <td>{r.tenderNo}</td>
                                                    <td>{r.company}</td>
                                                    <td>{formatDate(r.advertiseDate)}</td>
                                                    <td className={tenderDate(r.closingDate)}>{formatDate(r.closingDate)}</td>
                                                    {r.closingTime ? <td>{r.closingTime}</td> : <td style={{ paddingLeft: "40px" }}>-</td>}
                                                    <td>
                                                        {!r.document ? (
                                                            <button
                                                                className='download_doc_btn'
                                                                style={{
                                                                    opacity: 0.6,
                                                                    cursor: 'not-allowed',
                                                                }}
                                                                title="No Attachment Available"
                                                                disabled
                                                            >
                                                                Download
                                                            </button>
                                                        ) : (
                                                            <Link to={`${fileBaseUrl}/${r.document}`} target="_blank" className='download_doc_btn'>
                                                                Download
                                                            </Link>
                                                        )}
                                                    </td>
                                                    <td><span className={statusCheck(r.closingDate)}>{statusCheck(r.closingDate)}</span></td>
                                                    <td>
                                                        <span style={{ display: "flex", gap: "7px" }}>
                                                            {
                                                                statusCheck(r.closingDate) === 'Expired' ?
                                                                    <button className='selected_btn' onClick={() => selectTender(r, "detail")}>Detail</button> :
                                                                    <>
                                                                        <button className='selected_btn' onClick={() => selectTender(r, "detail")}>Detail</button>
                                                                        <button className='selected_btn' onClick={() => selectTender(r, "select")}>Assign</button>
                                                                    </>
                                                            }
                                                        </span>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </Table>
                            {allTendersData?.data.results?.length === 0 && <p className='text-center py-3' style={{ fontWeight: "600" }}>No Data Found</p>}

                            {
                                allTendersData?.data.results?.length > 0 &&
                                <Pagination
                                    totalPages={allTendersData?.data?.meta?.totalPages}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                    setLimit={setLimit}
                                    limit={limit} />
                            }
                        </div>
                }
            </div>
        </div>
    )
}

export default TenderDetails